<template>
  <div class="headers">
    <router-link to="/" class="left-logo">
      <i class="logo"></i>
      <span class="title">Yedeer</span>
    </router-link>
    <div class="centers">
      <YedeerStep></YedeerStep>
    </div>
    <div class="rights">
      <!-- <span  class="sign" @click="towhat('sign')">Sign Up</span> -->
      <router-link class="sign" to="/register">{{
        languageDataObj.signUp[language]
      }}</router-link>
      <router-link to="/login">
        <el-button class="btn" type="primary">{{
          languageDataObj.login[language]
        }}</el-button>
      </router-link>
    </div>
    <!-- <el-dialog
        :visible.sync="askDialog"
        width="30%"
        :before-close="handleClose">
        <h4>Join as a client or freelancer</h4>
        <span slot="footer" class="dialog-footer">
            <el-button @click="askDialog = false">取 消</el-button>
            <el-button type="primary" @click="askDialog = false">确 定</el-button>
        </span>
    </el-dialog> -->
  </div>
</template>

<script>
//引入组件
import YedeerStep from '@/components/YedeerStep/YedeerStep.vue'

export default {
  name: 'YHeader',
  components: { YedeerStep },
  data () {
    return {
      // askDialog:false
      languageDataObj: null
    }
  },
  created () {
    this.backLanguageText('officialWebsite')
  },
  watch: {
    language: function (val, oldVal) {
      this.backLanguageText('officialWebsite')
    }
  },
  methods: {
    // towhat(what){
    //     // this.askDialog = true
    //     this.$router.push({path:'/askwhat',query:{where:what}})
    //     // if(what ==='login'){
    //     //     // this.$router.push('/login')
    //     // }else if(what ==='sign'){
    //     //     // this.$router.push('/register')
    //     // }
    // },
    // handleClose(){

    // }
    backLanguageText (component) {
      this.languageDataObj = this.$language.changeLanguageType(
        this.language,
        component
      )
      // console.log('打印语言textoverview页面',this.languageDataObj)
    }
  },
  computed: {
    language () {
      return this.$store.state.languageType
    }
  }
}
</script>

<style lang="less" scoped>
* {
  text-decoration: none;
}
.headers {
  height: 52px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-logo {
  // background-color: rgb(51, 249, 57);
  display: flex;
  align-items: center;
  .logo {
    width: 36px;
    height: 36px;
    display: inline-block;
    background: url(@/assets/images/logo.svg) no-repeat center center;
  }
  .title {
    font-family: ArialRoundedmt;
    font-size: 20px;
    display: inline-block;
    margin-left: 10px;
    color: #000;
    height: 36px;
    line-height: 36px;
    // letter-spacing: 0.4px;
  }
}
.rights {
  font-size: 14px;
  font-family: ArialRoundedmt;
  display: flex;
  align-items: center;
  .btn {
    margin-left: 50px;
    background-color: #135ce7;
    font-weight: 600;
    height: 52px;
    padding: 0 46px;
  }
  .sign {
    cursor: pointer;
    height: 52px;
    line-height: 52px;
    color: #000;
  }
}
</style>
